export default {
  max: (size) =>
    `@media only screen and (max-width: ${Number.isInteger(size) ? `${size}px` : size})`,
  min: (size) =>
    `@media only screen and (min-width: ${Number.isInteger(size) ? `${size}px` : size})`,
  mobile: "@media only screen and (max-width: 767px)",
  tablet: "@media only screen and (max-width: 1279px)",
  desktop: "@media only screen and (min-width: 1280px)",
};
